/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback } from "react";
import styled from "styled-components";
import i18n, { use } from 'i18next';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

import PageContentWrapper from "../components/core/PageContentWrapper";
import PageContentWrapper2 from "../components/core/PageContentWrapper2";
import StepLoading from "../components/apply/StepLoading";
import STEP0 from "../components/apply_new/Step0";
import STEP1 from "../components/apply_new/Step1";
import STEP2 from "../components/apply_new/Step2";
import STEP3 from "../components/apply_new/Step3";
import STEP4 from "../components/apply_new/Step4";
import StepSuccess from "../components/apply_new/StepSuccess";
import StepPaymentFail from "../components/apply/StepPaymentFail";
import StepSubmitFail from "../components/apply/StepSubmitFail";
import useApplyNewStore from "../store/useApplyNewStore";
import useModalStore from "../store/useModalStore";
import useViewStore from "../store/useViewStore";
import ConstantConfig from "../components/core/BXHeader/config/ConstantConfig";
import withErrorHandling from "../function/withErrorHandling";
import { basename } from "../setting";
import { isEmpty, urlParam } from '@fe-util/common';


function Apply() {
  const { step, setStep, goNextStep, goBackStep, completePayment, applicationSubmit, failPayment } = useApplyNewStore();
  const { openModalConfirm } = useModalStore();
  const { t } = useTranslation();
  const { isMobileView, isPadView } = useViewStore();
  const navigate = useNavigate();

  const loadFailPayment = withErrorHandling(failPayment);

  // useEffect(() => { document.title = "醫療、旅遊及一般保險產品 │ 藍十字保險" }, [i18n.language]);

  useEffect(() => {
    // 是否跳过流程直接进入success page
    if (!isEmpty(urlParam('skipFlow'))) {
      setStep("success");
    }
  }, []);

  useEffect(() => {
    if (document.querySelector(`script[data-loaded="true"]`)) {
      return;
    }

    // const finishPayment = withErrorHandling(async () => {
    //   await completePayment();

    //   const success = await applicationSubmit();

    //   if (success) {
    //     setStep("success");
    //     window.history.pushState({}, '', `/${basename}/${i18n.language}/apply/success`);
    //   } else {
    //     setStep("submitFail");
    //   }
    // });

    const script = document.createElement('script');
    script.src = ConstantConfig.paymentJs;
    script.dataset.error = "errorCallback";
    script.dataset.cancel = "cancelCallback";
    script.dataset.complete = "completeCallback";
    script.dataset.loaded = "true";
    document.head.appendChild(script);

    /* eslint-disable */
    // const setPaymentCallback = () => {
    //   PaymentAction.errorCallback.core = (error) => {
    //     setStep("paymentFail");
    //     loadFailPayment();
    //     // setLoading(false);
    //   };

    //   PaymentAction.completeCallback.core = (data) => {
    //     finishPayment();
    //     // goNextStep();
    //     // console.log(data);
    //   };

    //   PaymentAction.cancelCallback.core = (error) => {
    //     setStep("paymentFail");
    //     loadFailPayment();
    //     // setLoading(false);
    //   };
    // }
    /* eslint-enable */

    // script.addEventListener('load', setPaymentCallback);

    // return () => {
    //   script.removeEventListener('load', setPaymentCallback);
    //   document.head.removeChild(script);
    // }
  }, []);

  return (
    <>
      {/* {step === "loading" && <StepLoading />} */}
      {step === "0" && <BackgroundImg $isPadView={isPadView}><STEP0 /></BackgroundImg>}
      {step === "1" && <STEP1 />}
      {/* {step === "2" && <STEP2 />} */}
      {step === "3" && <STEP3 />}
      {step === "4" && <STEP4 />}

      {step === "success" && <BackgroundImg $isPadView={isPadView}><StepSuccess /></BackgroundImg>}
      {step === "paymentFail" && <PageContentWrapper2><StepPaymentFail /></PageContentWrapper2>}
      {step === "submitFail" && <PageContentWrapper2><StepSubmitFail /></PageContentWrapper2>}
    </>
  );
}

const BackgroundImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${process.env.PUBLIC_URL}/images/apply_background.svg);
  width: 100%;
  ${(props) => props.$isPadView ? `height: 100%;` : `min-height: calc(100vh - 80px);`}
  padding: 16px 0px;
  padding-top:80px;
  background-size: cover;
  background-position: center;
`;

export default Apply;